module.exports = __webpack_public_path__ + "img/coinbankB03.849e829f.jpg";